import React, { ChangeEvent, useState } from "react";
import styled from "styled-components";
import { PasswordHint } from "../pages/me/MyProfilePage/styles";
import { LoginInputTextStyle } from "pages/auth/LoginPage/styles";
import { ReactComponent as VisibleIcon } from "@/assets/icons/visible.svg?react";

interface InputFieldProps {
  label: string;
  type: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  timer?: string; // 타이머 텍스트 (예: "3:45")
}

const ErrorText = styled.span`
  color: #ff3b30;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TimerWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #ff3b30;
  pointer-events: none;
  font-weight: 400;
  line-height: 1;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const InputField: React.FC<InputFieldProps> = ({
  label,
  type,
  value,
  onChange,
  placeholder,
  error,
  required,
  disabled,
  timer,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  const isPasswordField = type === "password";
  const inputType = isPasswordField
    ? isPasswordVisible
      ? "text"
      : "password"
    : type;
  return (
    <InputWrapper>
      <InputContainer>
        <LoginInputTextStyle
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          error={!!error}
          required={required}
          disabled={disabled}
          style={isPasswordField ? { paddingRight: "44px" } : timer ? { paddingRight: "60px" } : {}}
        />
        {isPasswordField && (
          <IconWrapper onClick={togglePasswordVisibility}>
            <VisibleIcon stroke={isPasswordVisible ? "#4A5DFF" : "#A6A6A6"} />
          </IconWrapper>
        )}
        {timer && (
          <TimerWrapper>
            {timer}
          </TimerWrapper>
        )}
      </InputContainer>

      {label === "비밀번호" && !error && (
        <PasswordHint error={!!error} style={{ padding: "0" }}>
          영어, 숫자, 특수문자를 조합하여 8~12자 이내로 설정해주세요.
        </PasswordHint>
      )}
      {error && <ErrorText>{error}</ErrorText>}
    </InputWrapper>
  );
};

export default InputField;
